module.exports = __webpack_public_path__ + "img/sms.bef1f61a.svg";